export abstract class AExt {

    protected vue: any;

    constructor(vue: any) {
        this.vue = vue;
    }
}
